import {computed, inject, Injectable} from '@angular/core';
import {SalesOfferSignalStore} from './sales-offer.signal-store';
import {BookmarkedOfferSignalStore} from './bookmarked-offer.signal-store';
import {FinishedOfferSignalStore} from './finished-offer-signal.store';
import {CurrentUserOfferSignalStore} from './current-user-offer.signal-store';
import {SalesScope} from '../../model/sales-scope';
import {SalesSignalStore} from '../sales/sales-signal.store';

/**
 * Service to manage common actions for the different sales offer stores
 */
@Injectable({
  providedIn: 'root'
})
export class SalesOfferStoreService {
  readonly salesSignalStore  = inject(SalesSignalStore);
  readonly salesOfferStore = inject(SalesOfferSignalStore);
  readonly bookmarkedOffersStore = inject(BookmarkedOfferSignalStore);
  readonly currentUserOfferSignalStore = inject(CurrentUserOfferSignalStore);
  readonly finishedOfferSignalStore = inject(FinishedOfferSignalStore);
  
  currentSearchParams = computed(() => {
    switch (this.salesSignalStore.currentScope()) {
    case SalesScope.SEARCH:
      return this.salesOfferStore.searchParams();
    case SalesScope.BOOKMARKS:
      return this.bookmarkedOffersStore.searchParams();
    case SalesScope.MY_AUCTIONS:
      return this.currentUserOfferSignalStore.searchParams();
    case SalesScope.FINISHED_OFFERS:
      return this.finishedOfferSignalStore.searchParams();
    }
  });

  currentAggregations = computed(() => {
    switch (this.salesSignalStore.currentScope()) {
    case SalesScope.SEARCH:
      return this.salesOfferStore.searchAggregation();
    case SalesScope.BOOKMARKS:
      return this.bookmarkedOffersStore.searchAggregation();
    case SalesScope.MY_AUCTIONS:
      return this.currentUserOfferSignalStore.searchAggregation();
    case SalesScope.FINISHED_OFFERS:
      return this.finishedOfferSignalStore.searchAggregation();
    }
  });

  updateSearchParamsAndAggregationsForCurrentScope(searchParams: VehicleOfferSearchParams) {
    switch (this.salesSignalStore.currentScope()) {
    case SalesScope.SEARCH:
      this.salesOfferStore.updateSearchParams(structuredClone(searchParams));
      this.salesOfferStore.fetchSearchAggregations();
      break;
    case SalesScope.BOOKMARKS:
      this.bookmarkedOffersStore.updateSearchParams(structuredClone(searchParams));
      this.bookmarkedOffersStore.fetchSearchAggregations();
      break;
    case SalesScope.MY_AUCTIONS:
      this.currentUserOfferSignalStore.updateSearchParams(structuredClone(searchParams));
      this.currentUserOfferSignalStore.fetchSearchAggregations();
      break;
    case SalesScope.FINISHED_OFFERS:
      this.finishedOfferSignalStore.updateSearchParams(structuredClone(searchParams));
      this.finishedOfferSignalStore.fetchSearchAggregations();
      break;
    }
  }
}
